import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class NameColumn extends Column {
    title = 'time-off-v3.name';
    property = 'name';
    type: CellDisplay = CellDisplay.string;
}
